<template>
  <div class="shipping-items">
    <b-table
      :items="shipping.itemsToShow"
      :fields="fields"
    >
      <template v-slot:cell(reference_code)="row">
        <h6 class="mb-0"><b-badge variant="dark">{{row.value}}</b-badge></h6>
      </template>
      <template v-slot:cell(description)="row">
        - {{row.item.description || 'No description'}}
      </template>
      <template v-slot:cell(quantity)="row">
        {{row.item.quantity || 1}} u.
      </template>
      <template v-slot:cell(serial_number)="row">
        <span v-if="row.item.original_serial_number && row.item.original_serial_number.length > 0">
          {{row.item.original_serial_number.join(', ')}}
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'ShippingItems',
  props: {
    shipping: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      itemEdit: {},
      fields: [
        {
          key: 'reference_code',
          label: this.$gettext('Reference Code')
        },
        {
          key: 'description',
          label: this.$gettext('Description')
        },
        {
          key: 'quantity',
          label: this.$gettext('Quantity')
        },
        {
          key: 'serial_number',
          label: this.$gettext('Serial Number')
        }
      ]
    }
  },
  watch: {
    itemEdit(val) {
      if (!val.serial_number) {
        this.itemEdit.serial_number = []
        this.itemEdit.original_serial_number = []
      }
    }
  },
  methods: {
    patchItem() {
      if (
        confirm(this.$gettext('Are you sure you want to EDIT the serial numbers of this shipping?\n\nWARNING: THIS ACTION CANNOT BE UNDONE!'))
      ) {
        const payload = {
          serial_number: this.itemEdit.serial_number.filter(Boolean)
        }
        payload.serial_number = payload.serial_number.length > 0 ? payload.serial_number : null
        this.$http.patch(this.$appConfig.api.baseUrl + 'shipping-items/' + this.itemEdit.id, payload)
          .then(response => {
            this.$emit('success', true)
            this.$root.$emit('bv::refresh::table', 'shippings')
            this.closeModal('modalItemEdit')
          })
      }
    }
  }
}
</script>
